import { render, staticRenderFns } from "./Nationalization.vue?vue&type=template&id=71263170"
import script from "./Nationalization.vue?vue&type=script&lang=js"
export * from "./Nationalization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports